module.exports = __webpack_public_path__ + "img/dulux-logo.184aab80.svg";